// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3hgsl","tab":"ProcedureTabs_tab__OeizR"};